import request from '@/utils/request'
export default {
  // 新建修改项目类型
  addOrEditProjectType(method, data) {
    return request({
      url: '/system/projectType',
      method,
      data
    })
  },
  // 查询或删除项目类型
  findOrDelProjectType(method, id) {
    return request({
      url: `/system/projectType/${id}`,
      method
    })
  },
  // 获取项目类型列表
  getProjectTypeList() {
    return request({
      url: '/system/projectType/list',
      method: 'get'
    })
  },
  // 新建修改岗位类型
  addOrEditStationType(method, data) {
    return request({
      url: '/system/stationType',
      method,
      data
    })
  },
  // 删除岗位类型
  delStationType(id) {
    return request({
      url: `/system/stationType/${id}`,
      method: 'delete'
    })
  },

  // 查询岗位类型列表
  getStationTypeList() {
    return request({
      url: '/system/stationType/list',
      method: 'get'
    })
  },
  // 新增修改技能标签
  addOrEditLabel(method, data) {
    return request({
      url: '/system/label',
      method,
      data
    })
  },
  // 删除技能标签
  delLabel(id) {
    return request({
      url: `/system/label/${id}`,
      method: 'delete'
    })
  },
  // 查询技能标签列表
  getLabelList() {
    return request({
      url: '/system/label/list',
      method: 'get'
    })
  },

  // 新增或修改部门标签
  addOrEditDept(method, data) {
    return request({
      url: '/system/dept/label',
      method,
      data
    })
  },

  // 删除部门标签
  delDept(id) {
    return request({
      url: `/system/dept/label/${id}`,
      method: 'delete'
    })
  },
  // 查询部门标签列表
  getDeptList() {
    return request({
      url: '/system/dept/label/list',
      method: 'get'
    })
  },
  // 新增项目部门
  addOrEditProjectDept(method, data) {
    return request({
      url: '/system/projectDept',
      method,
      data
    })
  },
  // 获取部门详细信息或删除
  getOrDelProjectDept(method, id) {
    return request({
      url: `/system/projectDept/${id}`,
      method
    })
  },
  // 查询项目部门列表
  getPojectDeptList() {
    return request({
      url: '/system/projectDept/list',
      method: 'get'
    })
  }

}